import React from "react";
import { TextComponent } from "../../../../components";
import styles from "./Profile.module.css";
import Person from "../../../../assets/staticImages/cplImage1.png";
import { FiEdit } from "react-icons/fi";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import dummyImg from "../../../../assets/dummy.jpg";
const Profile = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);
  console.log("USewr", user);
  const data = [
    {
      name: "Personal Information",
      navigate: "/profile",
    },
    {
      name: "Business Information",
      navigate: "/profile/BusinessInfo",
    },
    {
      name: "Staff",
      navigate: "/profile/subVendors",
    },
    {
      name: "Gallery",
      navigate: "/profile/gallery",
    },
  ];

  if (user?.vendor_type == "individual") {
    data.splice(1, 2);
  }

  const renderItem = (item) => (
    <div className={styles.option_tab_view}>
      <div
        className={styles.option_tab}
        onClick={() => navigate(item?.navigate)}
      >
        <TextComponent text={item?.name} textClass={styles.text} />
        <FaChevronRight size={25} />
      </div>
    </div>
  );

  return (
    <div className={styles.main_box}>
      <div className={styles.initial_box}>
        <div className={styles.profile_image_view}>
          <img src={user?.image || dummyImg} className={styles.profile_image} />
        </div>

        <TextComponent text={user?.name || "--"} textClass={styles.heading} />
        <TextComponent
          text={user?.email ? user?.email : "--"}
          textClass={styles.sub_heading}
        />
      </div>

      <div className={styles.options_inner_bar}>
        <List dataSource={data} renderItem={renderItem} />
      </div>
    </div>
  );
};

export default Profile;
